import $ from "jquery";
import protect from "flow/protect";
import MyFlow from "flow/MyFlow";

function wrap<T>(myFlow: MyFlow, promise: JQueryPromise<T>): JQueryPromise<T> {
    function done(...params: any[]): JQueryPromise<T> {
        const callbacks = unpack(params);
        $.each(callbacks, function (_, callback) {
            promise.done(protect(myFlow, this, callback));
        });
        return this;
    }

    function fail(...params: any[]): JQueryPromise<T> {
        const callbacks = unpack(params);
        $.each(callbacks, function (_, callback) {
            promise.fail(protect(myFlow, this, callback));
        });
        return this;
    }

    function progress(...params: any[]): JQueryPromise<T> {
        const callbacks = unpack(params);
        $.each(callbacks, function (_, callback) {
            promise.progress(protect(myFlow, this, callback));
        });
        return this;
    }

    function always(...params: any[]): JQueryPromise<T> {
        const callbacks = unpack(params);
        $.each(callbacks, function (_, callback) {
            promise.always(protect(myFlow, this, callback));
        });
        return this;
    }

    function then(doneFilter: any, failFilter?: any, progressFilter?: any): JQueryPromise<T> {
        const protectedDoneFilter = doneFilter ? protect(myFlow, this, doneFilter) : undefined;
        const protectedFailFilter = failFilter ? protect(myFlow, this, failFilter) : undefined;
        const protectedProgressFilter = progressFilter ? protect(myFlow, this, progressFilter) : undefined;

        return wrap(myFlow, promise.then(protectedDoneFilter, protectedFailFilter, protectedProgressFilter));
    }

    function catchFunc(...params: any[]) {
        const callbacks = unpack(params);
        $.each(callbacks, function (_, callback) {
            promise.catch(protect(myFlow, this, callback));
        });
        return this;
    }

    function unpack(...params: any[]) {
        const list: any[] = [];

        (function addToList(args) {
            Array.from(args).forEach((arg: any) => {
                const type = $.type(arg);
                if (type === "function") {
                    list.push(arg);
                } else if (arg && arg.length && type !== "string") {
                    // Inspect recursively
                    addToList(arg);
                }
            });
        })(params);

        return list;
    }

    return {
        done: done,
        fail: fail,
        progress: progress,
        always: always,
        then: then,
        catch: catchFunc,
        state: promise.state,
        promise: promise.promise,
        pipe: promise.pipe
    };
}

export default {
    wrap: wrap
};
